module.exports = __webpack_public_path__ + "static/iconWA-54e711c0060dddd3b24f9657e06fb61f.png";